import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelLCD extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #screen {
            font-size: 72px;
            padding: 20px;
            background-color: #00ff00;
            color: #444444;
            font-family: 'DS-Digital-Italic';
            text-shadow: 0px 0px 20px rgba(45,255,196,0.9);
            box-shadow: inset 0px 0px 20px 20px rgba(45,255,196,0.9);
        }
        slot {
            text-shadow: 2px 2px 4px gba(45,255,196,0.9);
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="lcd-container">
        <div id="screen">
        <slot></slot>
        </div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'lcd-id', 'color', 'size', 'x', 'y', 'scale', 'orientation', 'text'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#lcd-container');
    }
  
    setup = () => {
        this.observedMessages = ['lcd-text'];
        this.subscribe(this.observedMessages);   
    }
    
    teardown = () => {
        this.unsubscribe(this.observedMessages);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'size') {
            this.size = Number(newValue);
        }
        if (name === 'x') {
            this.container.style.position = 'fixed';
            this.x = newValue;
            this.container.style.left = newValue;
        }
        if (name === 'y') {
            this.container.style.position = 'fixed';
            this.y = newValue;
            this.container.style.top = newValue;
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
    }
}
